import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import {authService} from "../services/authenticationServiceInstance";
import StorageService from "../services/storageService";
import store  from '../store/index';

const refreshAuthLogic = (failedRequest) =>  
{
    let storageService = new StorageService();
    let authMode = storageService.get('auth_mode');

    if(authMode !== 'cw'){

        authService.silentRefresh().then(token =>{
            failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token;
            return Promise.resolve();
        }).catch((error)=>{
            console.log('failed to refersh token '+error)
            return Promise.reject();
        });
    }else{
        return store.dispatch('setUnAuthorizedUser');
    }
};

 
// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic, {statusCodes:[401]});
 